import React from 'react';
import Slider from "../components/Slider/Slider";

export default ({data})=>{
  
    return (
      <React.Fragment>
      <header id="portfolio-detail-header">
         <nav id="nav-wrap">
            <a className="mobile-btn" href="#nav-wrap" title="Show navigation">Show navigation</a>
          <a className="mobile-btn" href="#" title="Hide navigation">Hide navigation</a>
            <ul id="nav" className="nav" style={{backgroundColor: "#292323"}}>
               <li><a className="smoothscroll" href="/">Return To Main Page</a></li>
            </ul>
         </nav>
         <div className="row banner">
            <div className="banner-text">
               
               <h2 className="responsive-headline" style={{color: "white"}}>{data.title}</h2>
               <hr/>
                <h3>
                    {data.description}
                </h3>
                <p>
                    {data.period}
                </p>
                <Slider data={data} />

            </div>
         </div>
         <p className="scrolldown">
            <a className="smoothscroll" href="#portfolio-detail-description"><i className="icon-down-circle"></i></a>
         </p>
      </header>
      </React.Fragment>
    
    )
}